module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAATCAMAAACjpw26AAAASFBMVEUFBwgFBwgFBwgFBwgFBwgFBwgFBwhHcEwFBwgFBwgFBwgFBwgFBwgFBwgFBwgFBwgFBwgFBwgFBwgFBwgFBwgFBwgFBwgFBwjE3RD/AAAAF3RSTlPg0y3r3CQVABzkJ1hS/c/sxMPZ3hThF9tOGCgAAABwSURBVBjTjdBZDoAgDARQRGpBcV96/5sKuLeaOF/khZShCq/4fjqO6tKqpqyQrHM6/caoXfBFMEJwYwUjzLs/Ga3ZnHFyB6h4Woqu6C2NuB3KU6757CILM0rRZEgvMo49Rvj3y/LUHxv82Df67lBcAf23DgurSoDnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/images/icon-arrow-med.png
// module id = 640
// module chunks = 0